"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultContentComponent = void 0;
exports.DefaultFeaturedComponent = DefaultFeaturedComponent;
exports.DefaultFooterComponent = DefaultFooterComponent;
exports.DefaultHeaderComponent = DefaultHeaderComponent;
exports["default"] = exports.contentTypes = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx0 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _Color = _interopRequireDefault(require("../Color"));
var _Image = _interopRequireDefault(require("../Image"));
var _context2 = _interopRequireDefault(require("./context"));
var _excluded = ["classNames", "children"],
  _excluded2 = ["classNames", "title", "subtitle", "children", "footerContent", "footerActions", "ImageProps", "featuredChildren", "featuredActions", "FeaturedComponent", "ContentContainerComponent", "HeaderComponent", "FooterComponent", "ContentComponent", "FeaturedComponentProps", "ContentContainerComponentProps", "HeaderComponentProps", "FooterComponentProps", "ContentComponentProps", "isGallery", "galleryWithContent", "overflowVisible"],
  _excluded3 = ["classNames", "children", "defaultClassName", "size", "elevation", "borderRadius", "style", "arrow", "arrowClassName", "enableContentContainer", "ContentComponent", "ContentComponentProps"],
  _excluded4 = ["variant"];
var defaultStyle = require("./../empty_css.js")["default"];
var defaultContentStyle = require("./../empty_css.js")["default"];
function DefaultFeaturedComponent(props) {
  var className = props.className,
    classNames = props.classNames,
    featuredContent = props.featuredContent,
    featuredActions = props.featuredActions,
    _props$classPrefix = props.classPrefix,
    classPrefix = _props$classPrefix === void 0 ? 'card' : _props$classPrefix;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, featuredContent || featuredActions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx0["default"])(classNames[classPrefix + 'Featured'], className)
  }, featuredContent ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'FeaturedContent']
  }, featuredContent) : null, featuredActions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'FeaturedActions']
  }, featuredActions) : null) : null);
}
function DefaultHeaderComponent(props) {
  var classNames = props.classNames,
    _props$classPrefix2 = props.classPrefix,
    classPrefix = _props$classPrefix2 === void 0 ? 'modal' : _props$classPrefix2,
    title = props.title,
    subtitle = props.subtitle,
    headerActions = props.headerActions;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, title || headerActions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'Header']
  }, title || subtitle ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'Title']
  }, title, subtitle) : null, headerActions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'HeaderActions']
  }, headerActions) : null) : null);
}
function DefaultFooterComponent(props) {
  var classNames = props.classNames,
    footerContent = props.footerContent,
    footerActions = props.footerActions,
    _props$classPrefix3 = props.classPrefix,
    classPrefix = _props$classPrefix3 === void 0 ? 'modal' : _props$classPrefix3;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, footerContent || footerActions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'Footer']
  }, footerContent ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'FooterContent']
  }, footerContent) : null, footerActions ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames[classPrefix + 'FooterActions']
  }, footerActions) : null) : null);
}
var DefaultContentComponent = exports.DefaultContentComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classNames = props.classNames,
    children = props.children,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", Object.assign({}, rest, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("div", null, children));
});
var contentTypes = exports.contentTypes = {
  Modal: function Modal(props) {
    var _useContext = (0, _react.useContext)(_context["default"]),
      _useContext$additiona = _useContext.additionalStyles,
      additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
      useStyle = _useContext.useStyle;
    var _props$classNames = props.classNames,
      classNames = _props$classNames === void 0 ? additionalStyles.paperContent || defaultContentStyle : _props$classNames,
      title = props.title,
      headerActions = props.headerActions,
      children = props.children,
      footerContent = props.footerContent,
      footerActions = props.footerActions,
      _props$HeaderComponen = props.HeaderComponent,
      HeaderComponent = _props$HeaderComponen === void 0 ? DefaultHeaderComponent : _props$HeaderComponen,
      _props$FooterComponen = props.FooterComponent,
      FooterComponent = _props$FooterComponen === void 0 ? DefaultFooterComponent : _props$FooterComponen,
      _props$ContentCompone = props.ContentComponent,
      ContentComponent = _props$ContentCompone === void 0 ? DefaultContentComponent : _props$ContentCompone,
      _props$HeaderComponen2 = props.HeaderComponentProps,
      HeaderComponentProps = _props$HeaderComponen2 === void 0 ? {} : _props$HeaderComponen2,
      _props$FooterComponen2 = props.FooterComponentProps,
      FooterComponentProps = _props$FooterComponen2 === void 0 ? {} : _props$FooterComponen2,
      _props$ContentCompone2 = props.ContentComponentProps,
      ContentComponentProps = _props$ContentCompone2 === void 0 ? {} : _props$ContentCompone2,
      overflowVisible = props.overflowVisible;
    if (classNames !== additionalStyles.paperContent) {
      if (typeof useStyle === 'function') {
        useStyle(classNames);
      }
    }
    var footerChildren = footerActions || footerContent;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx0["default"])(classNames.modal, (0, _defineProperty2["default"])({}, classNames.modalWithoutFooter, !footerChildren))
    }, /*#__PURE__*/_react["default"].createElement(HeaderComponent, Object.assign({}, HeaderComponentProps, {
      classNames: classNames,
      title: title,
      headerActions: headerActions
    })), /*#__PURE__*/_react["default"].createElement(ContentComponent, Object.assign({
      classNames: classNames
    }, ContentComponentProps, {
      className: (0, _clsx0["default"])(classNames.modalContent, (0, _defineProperty2["default"])({}, classNames.overflowVisible, overflowVisible), ContentComponentProps.className)
    }), children), /*#__PURE__*/_react["default"].createElement(FooterComponent, Object.assign({}, FooterComponentProps, {
      classNames: classNames,
      footerContent: footerContent,
      footerActions: footerActions
    })));
  },
  Drawer: function Drawer(props) {
    var _useContext2 = (0, _react.useContext)(_context["default"]),
      _useContext2$addition = _useContext2.additionalStyles,
      additionalStyles = _useContext2$addition === void 0 ? {} : _useContext2$addition,
      useStyle = _useContext2.useStyle;
    var _props$classNames2 = props.classNames,
      classNames = _props$classNames2 === void 0 ? additionalStyles.paperContent || defaultContentStyle : _props$classNames2,
      title = props.title,
      headerActions = props.headerActions,
      children = props.children,
      footerContent = props.footerContent,
      footerActions = props.footerActions,
      _props$HeaderComponen3 = props.HeaderComponent,
      HeaderComponent = _props$HeaderComponen3 === void 0 ? DefaultHeaderComponent : _props$HeaderComponen3,
      _props$FooterComponen3 = props.FooterComponent,
      FooterComponent = _props$FooterComponen3 === void 0 ? DefaultFooterComponent : _props$FooterComponen3,
      _props$ContentCompone3 = props.ContentComponent,
      ContentComponent = _props$ContentCompone3 === void 0 ? DefaultContentComponent : _props$ContentCompone3,
      _props$HeaderComponen4 = props.HeaderComponentProps,
      HeaderComponentProps = _props$HeaderComponen4 === void 0 ? {} : _props$HeaderComponen4,
      _props$FooterComponen4 = props.FooterComponentProps,
      FooterComponentProps = _props$FooterComponen4 === void 0 ? {} : _props$FooterComponen4,
      _props$ContentCompone4 = props.ContentComponentProps,
      ContentComponentProps = _props$ContentCompone4 === void 0 ? {} : _props$ContentCompone4,
      overflowVisible = props.overflowVisible;
    if (classNames !== additionalStyles.paperContent) {
      if (typeof useStyle === 'function') {
        useStyle(classNames);
      }
    }
    var footerChildren = footerActions || footerContent;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx0["default"])(classNames.drawer, (0, _defineProperty2["default"])({}, classNames.drawerWithoutFooter, !footerChildren))
    }, /*#__PURE__*/_react["default"].createElement(HeaderComponent, Object.assign({}, HeaderComponentProps, {
      classNames: classNames,
      title: title,
      headerActions: headerActions,
      classPrefix: 'drawer'
    })), /*#__PURE__*/_react["default"].createElement(ContentComponent, Object.assign({
      classNames: classNames
    }, ContentComponentProps, {
      className: (0, _clsx0["default"])(classNames.drawerContent, (0, _defineProperty2["default"])({}, classNames.overflowVisible, overflowVisible), ContentComponentProps.className)
    }), children), /*#__PURE__*/_react["default"].createElement(FooterComponent, Object.assign({}, FooterComponentProps, {
      classNames: classNames,
      footerContent: footerContent,
      footerActions: footerActions,
      classPrefix: 'drawer'
    })));
  },
  Card: function Card(props) {
    var _useContext3 = (0, _react.useContext)(_context["default"]),
      _useContext3$addition = _useContext3.additionalStyles,
      additionalStyles = _useContext3$addition === void 0 ? {} : _useContext3$addition,
      useStyle = _useContext3.useStyle;
    var _props$classNames3 = props.classNames,
      classNames = _props$classNames3 === void 0 ? additionalStyles.paperContent || defaultContentStyle : _props$classNames3,
      title = props.title,
      subtitle = props.subtitle,
      children = props.children,
      footerContent = props.footerContent,
      footerActions = props.footerActions,
      _props$ImageProps = props.ImageProps,
      ImageProps = _props$ImageProps === void 0 ? {} : _props$ImageProps,
      featuredChildren = props.featuredChildren,
      featuredActions = props.featuredActions,
      _props$FeaturedCompon = props.FeaturedComponent,
      FeaturedComponent = _props$FeaturedCompon === void 0 ? DefaultFeaturedComponent : _props$FeaturedCompon,
      _props$ContentContain = props.ContentContainerComponent,
      ContentContainerComponent = _props$ContentContain === void 0 ? 'div' : _props$ContentContain,
      _props$HeaderComponen5 = props.HeaderComponent,
      HeaderComponent = _props$HeaderComponen5 === void 0 ? DefaultHeaderComponent : _props$HeaderComponen5,
      _props$FooterComponen5 = props.FooterComponent,
      FooterComponent = _props$FooterComponen5 === void 0 ? DefaultFooterComponent : _props$FooterComponen5,
      _props$ContentCompone5 = props.ContentComponent,
      ContentComponent = _props$ContentCompone5 === void 0 ? DefaultContentComponent : _props$ContentCompone5,
      _props$FeaturedCompon2 = props.FeaturedComponentProps,
      FeaturedComponentProps = _props$FeaturedCompon2 === void 0 ? {} : _props$FeaturedCompon2,
      _props$ContentContain2 = props.ContentContainerComponentProps,
      ContentContainerComponentProps = _props$ContentContain2 === void 0 ? {} : _props$ContentContain2,
      _props$HeaderComponen6 = props.HeaderComponentProps,
      HeaderComponentProps = _props$HeaderComponen6 === void 0 ? {} : _props$HeaderComponen6,
      _props$FooterComponen6 = props.FooterComponentProps,
      FooterComponentProps = _props$FooterComponen6 === void 0 ? {} : _props$FooterComponen6,
      _props$ContentCompone6 = props.ContentComponentProps,
      ContentComponentProps = _props$ContentCompone6 === void 0 ? {} : _props$ContentCompone6,
      isGallery = props.isGallery,
      galleryWithContent = props.galleryWithContent,
      overflowVisible = props.overflowVisible,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
    var isCardList = rest.isCardList,
      headerActions = rest.headerActions,
      _rest$labelChildren = rest.labelChildren,
      labelChildren = _rest$labelChildren === void 0 ? null : _rest$labelChildren;
    if (classNames !== additionalStyles.paperContent) {
      if (typeof useStyle === 'function') {
        useStyle(classNames);
      }
    }
    var imageChildren = (0, _react.useMemo)(function () {
      return props.ImageProps ? /*#__PURE__*/_react["default"].createElement(_Image["default"], Object.assign({}, ImageProps, {
        className: (0, _clsx0["default"])(classNames.cardImage, ImageProps.className)
      })) : null;
    }, [ImageProps.src]);
    if (isGallery || !imageChildren) {
      isCardList = false;
    }
    if (isCardList) {
      headerActions = headerActions || labelChildren ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, labelChildren, headerActions) : null;
      labelChildren = null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx0["default"])(classNames.card, (0, _defineProperty2["default"])({}, classNames.cardGallery, isGallery), (0, _defineProperty2["default"])({}, classNames.cardGalleryWithContent, isGallery && galleryWithContent), (0, _defineProperty2["default"])({}, classNames.cardList, isCardList))
    }, featuredChildren || featuredActions || !imageChildren && labelChildren || isGallery && labelChildren || imageChildren ? /*#__PURE__*/_react["default"].createElement("div", {
      className: classNames.cardImageAndFeaturedContainer
    }, imageChildren, featuredChildren || featuredActions || !imageChildren && labelChildren || isGallery && labelChildren ? /*#__PURE__*/_react["default"].createElement(FeaturedComponent, Object.assign({}, FeaturedComponentProps, {
      classNames: classNames,
      className: (0, _clsx0["default"])((0, _defineProperty2["default"])({}, classNames.cardFeaturedRelative, !imageChildren), FeaturedComponentProps.className),
      featuredContent: featuredChildren || !imageChildren && labelChildren || isGallery && labelChildren ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, featuredChildren, !imageChildren && labelChildren || isGallery && labelChildren ? labelChildren : null) : null,
      featuredActions: featuredActions,
      classPrefix: 'card'
    })) : null) : null, /*#__PURE__*/_react["default"].createElement(ContentContainerComponent, Object.assign({}, ContentContainerComponentProps, {
      className: (0, _clsx0["default"])(classNames.cardContainer, ContentContainerComponentProps.className)
    }), imageChildren && !isGallery && labelChildren ? /*#__PURE__*/_react["default"].createElement("div", {
      className: classNames.cardLabelChildren
    }, labelChildren) : null, /*#__PURE__*/_react["default"].createElement(HeaderComponent, Object.assign({}, HeaderComponentProps, {
      classNames: classNames,
      title: title,
      subtitle: subtitle,
      headerActions: headerActions,
      classPrefix: 'card'
    })), /*#__PURE__*/_react["default"].createElement(ContentComponent, Object.assign({
      classNames: classNames
    }, ContentComponentProps, {
      className: (0, _clsx0["default"])(classNames.cardContent, (0, _defineProperty2["default"])({}, classNames.overflowVisible, overflowVisible), ContentComponentProps.className)
    }), children), /*#__PURE__*/_react["default"].createElement(FooterComponent, Object.assign({}, FooterComponentProps, {
      classNames: classNames,
      footerContent: footerContent,
      footerActions: footerActions,
      classPrefix: 'card'
    }))));
  }
};
function Content(props) {
  var classNames = props.classNames,
    _props$enableContentC = props.enableContentContainer,
    enableContentContainer = _props$enableContentC === void 0 ? false : _props$enableContentC,
    _props$ContentCompone7 = props.ContentComponentProps,
    ContentComponentProps = _props$ContentCompone7 === void 0 ? {} : _props$ContentCompone7,
    children = props.children;
  var _props$ContentCompone8 = props.ContentComponent,
    ContentComponent = _props$ContentCompone8 === void 0 ? enableContentContainer ? 'div' : null : _props$ContentCompone8;
  if (contentTypes[ContentComponent]) {
    ContentComponent = contentTypes[ContentComponent];
  }
  if (enableContentContainer || ContentComponent) {
    return /*#__PURE__*/_react["default"].createElement(ContentComponent, Object.assign({}, ContentComponentProps, {
      className: (0, _clsx0["default"])(classNames.paperContentContainer, ContentComponentProps.className)
    }), children);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
}
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext4 = (0, _react.useContext)(_context["default"]),
    componentsStyle = _useContext4.componentsStyle,
    useStyle = _useContext4.useStyle;
  var paperContext = (0, _react.useContext)(_context2["default"]);
  var _props$classNames4 = props.classNames,
    classNames = _props$classNames4 === void 0 ? componentsStyle || defaultStyle : _props$classNames4,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$defaultClassNa = props.defaultClassName,
    defaultClassName = _props$defaultClassNa === void 0 ? '' : _props$defaultClassNa,
    _props$size = props.size,
    size = _props$size === void 0 ? 'default' : _props$size,
    _props$elevation = props.elevation,
    elevation = _props$elevation === void 0 ? 'paper-contained' : _props$elevation,
    borderRadius = props.borderRadius,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$arrow = props.arrow,
    arrow = _props$arrow === void 0 ? false : _props$arrow,
    arrowClassName = props.arrowClassName,
    enableContentContainer = props.enableContentContainer,
    ContentComponent = props.ContentComponent,
    ContentComponentProps = props.ContentComponentProps,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  var _rest2$variant = rest2.variant,
    variant = _rest2$variant === void 0 ? 'paper' : _rest2$variant,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded4);
  variant = variant === 'inherit' ? paperContext.variant : variant;
  if (classNames !== componentsStyle) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var styleWidthElevation = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, (typeof elevation == 'number' || typeof elevation == 'string') && variant !== 'outlined' ? {
    boxShadow: 'var(--digby-shadow-color) var(--digby-shadow-' + elevation + ')'
  } : {}), typeof borderRadius === 'string' || typeof borderRadius === 'number' ? {
    borderRadius: borderRadius
  } : {}), style);
  return /*#__PURE__*/_react["default"].createElement(_context2["default"].Provider, {
    value: {
      variant: variant
    }
  }, /*#__PURE__*/_react["default"].createElement(_Color["default"], Object.assign({
    ref: ref
  }, Object.keys(styleWidthElevation).length ? {
    style: styleWidthElevation
  } : {}, {
    defaultClassName: (0, _clsx0["default"])(classNames.paper, classNames['paper-' + size], classNames['paper-' + variant], defaultClassName),
    variant: props.variant === 'inherit' ? 'inherit' : variant
  }, rest), arrow ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx0["default"])(classNames.paperArrow, arrowClassName),
    "data-popper-arrow": ''
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _objectSpread2["default"])({}, (typeof elevation == 'number' || typeof elevation == 'string') && variant !== 'outlined' ? {
      boxShadow: 'var(--digby-shadow-color) var(--digby-shadow-' + elevation + ')'
    } : {})
  })) : null, /*#__PURE__*/_react["default"].createElement(Content, {
    classNames: classNames,
    ContentComponent: ContentComponent,
    ContentComponentProps: ContentComponentProps,
    enableContentContainer: enableContentContainer
  }, children)));
});